module.exports = __webpack_public_path__ + "media/images/check-box-db357f790e223eb2ed3a193fb6325516.svg";